import React from 'react';
import { withTranslation } from 'react-i18next';

// styles
import './ycGroup.scss';

import imgGroup from '../../assets/images/c-group/ishogroupe.png';

export const YcGroup = withTranslation(['about-us'])(
  class YcGroupClass extends React.PureComponent {
    constructor(props) {
      super();
    }

    render() {
      const { t } = this.props;

      return (
        <div className="c-group">
          <div className="content">
            <h2 dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.title') }} />
            <p className="desc" dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.desc') }} />
            <div className="graph row">
              <div className="col-xl-5">
                <div className="box">
                  <p className="subtitle" dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.title') }} />
                  <br />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.experiences.bank') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.experiences.computer') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.experiences.tradespeople') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.experiences.book-keeper') }} />
                  <br />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.diversified.experiences.contributors') }} />
                </div>
                <div className="box blue-box">
                  <p className="subtitle" dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.title') }} />
                  <br />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.groups.web') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.groups.import-export') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.groups.rental') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.groups.real-estate') }} />
                  <p dangerouslySetInnerHTML={{ __html: t('about-us.isho-group.trades.groups.breweries') }} />
                </div>
              </div>
              <div className="col-xl-7">
                <img className="img-group" src={imgGroup} alt="Groupe" />
              </div>
            </div>
          </div>
        </div>
      );
    }
  },
);
